import { Controller, useFormContext } from 'react-hook-form';
import styles from './ScanningSettings.module.css';
import { Input, Tag, Tooltip } from '@dsi/react-eds';
import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import React from 'react';

enum ScanStatus {
    Success = 'success',
    Failure = 'failure',
    Pending = 'pending',
    Running = 'running',
    Stopped = 'stopped',
}

const ScanningSettings: React.FC = () => {
    const { control, watch, formState: { errors } } = useFormContext();
    const scanStatus = watch('success') || ScanStatus.Success;
    const now = new Date();
    const timeString = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    return (
        <div className={styles.scanningContainer}>
            <div className={styles.toggleRow}>
                <div className={styles.toggleContainer}>
                    <div className={styles.settingsTitle}>
                        Execution Interval
                    </div>
                </div>
            </div>
            <div className={styles.scanningDescription}>Last Execution</div>
            <div className={styles.scanningInfoRow}>
                <div className={`${styles.scanningTime} ${styles.whiteText}`}>{timeString}</div>
                <div className="tags">
                    {(scanStatus === ScanStatus.Success || scanStatus === ScanStatus.Running) && (
                        <ReactEDSWrapper id="tagSuccess" className="tag big green" component={Tag}>
                            Success
                        </ReactEDSWrapper>
                    )}
                    {(scanStatus === ScanStatus.Failure || scanStatus === ScanStatus.Stopped) && (
                        <ReactEDSWrapper id="tagFail" className="tag big red" component={Tag}>
                            Failure
                        </ReactEDSWrapper>
                    )}
                    {scanStatus === ScanStatus.Pending && (
                        <ReactEDSWrapper id="tagPending" className="tag big yellow" component={Tag}>
                            Pending
                        </ReactEDSWrapper>
                    )}
                </div>
            </div>

            <div className={`${styles.scanningsTitle} ${styles.whiteText}`}>Software Gateway Scanning</div>
            <p className={styles.scanningDescription}>
                Automatically scans the Software Gateway at regular intervals to keep onboarding data current.
            </p>
            <div className={styles.formRow}>
                <div className={styles.fieldWrapper}>
                    <label htmlFor="span" className={styles.whiteText}>
                        Span <span className={styles.requiredAsterisk}> *</span> <ReactEDSWrapper component={Tooltip} message="Defines how many days back from today the system should chech for activity or data." pointer>
                            <span>
                                <i className={`icon icon-info ${styles.infoIcon}`}></i>
                            </span>
                        </ReactEDSWrapper>
                    </label>
                    <div className={styles.daysContainer}>
                        <Controller
                            name="ticket_start_days"
                            control={control}
                            render={({ field }) => (
                                <ReactEDSWrapper
                                    component={Input}
                                    type="number"
                                    min="1"
                                    max="365"
                                    {...field}
                                    value={field.value ?? ''}
                                    className={errors.ticket_start_days ? `${styles.inputField} ${styles.inputError}` : styles.inputField}
                                />
                            )}
                        />
                        <div className={styles.suffix}>Days</div>
                    </div>
                    {errors.ticket_start_days && (
                        <span className={`error ${styles.errorText}`}>
                            <span className={styles.dangerIcon} aria-label="error" role="img">&#9888;</span>
                            {typeof errors.ticket_start_days.message === 'string' ? errors.ticket_start_days.message : 'Max: 365 days'}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ScanningSettings;
